export default "__VITE_ASSET__D65jtuZi__"